<script context="module" lang="ts">
    export const cssClasses = [
        "max-width-1200px",
        "width-full",
        "width-75percent",
        "width-60percent",
        "width-50percent",
        "width-40percent",
        "width-33percent",
        "width-25percent",
        "min-width-250px",
        "min-width-400px",
        "min-width-500px",
        "min-width-600px",
        "carousel",
        "breakPoint-1000px",
        "breakPoint-800px",
        "breakPoint-600px",
        "sticky",
    ];
</script>

<script lang="ts">
    import Carousel from "./Carousel.svelte";
    export let data: any = {};
    export let id: string;

    let isCarousel =
        data.cssClasses && data.cssClasses.indexOf("carousel") !== -1;
</script>

{#if isCarousel}
    <Carousel {id}><slot /></Carousel>
{:else}
    <slot />
{/if}

<style lang="scss">
    :global {
        .blockContainer {
            height: 100%;
        }

        .blockContainer-width-full {
            width: 100% !important;
            margin-bottom: 10px;
        }

        .blockContainer-min-width-250px {
            min-width: 250px !important;
        }

        .blockContainer-min-width-400px {
            min-width: 400px !important;
        }

        .blockContainer-min-width-600px {
            min-width: 600px !important;
        }

        .blockContainer-min-width-500px {
            min-width: 500px !important;
        }

        .blockContainer-max-width-1200px {
            max-width: 1300px !important;
            margin: auto auto 10px auto;
            width: 100%;
        }

        .blockContainer-width-60percent {
            width: 60% !important;
        }

        .blockContainer-width-75percent {
            width: 75% !important;
        }

        .blockContainer-width-50percent {
            width: 50% !important;
        }

        .blockContainer-width-40percent {
            width: 40% !important;
        }

        .blockContainer-width-33percent {
            width: 33% !important;
        }

        .blockContainer-width-25percent {
            width: 25% !important;
        }

        .blockContainer-carousel {
            width: 100% !important;
            margin-bottom: 10px;
            height: auto;
            flex-direction: row !important;
            overflow-x: scroll;
            overflow-y: hidden;
            flex-wrap: nowrap !important;
        }

        .blockContainer-sticky {
            position: -webkit-sticky;
            position: sticky;
            top: 0;
        }
    }

    @media only screen and (max-width: 1000px) {
        :global {
            .blockContainer-breakPoint-1000px {
                width: 100% !important;
                min-width: 100% !important;
                position: relative !important;
            }
        }
    }

    @media only screen and (max-width: 800px) {
        :global {
            .blockContainer-breakPoint-800px {
                width: 100% !important;
                min-width: 100% !important;
                position: relative !important;
            }
        }
    }

    @media only screen and (max-width: 600px) {
        :global {
            .blockContainer-breakPoint-600px {
                width: 100% !important;
                min-width: 100% !important;
                position: relative !important;
            }
        }
    }

    @media only screen and (max-width: 1000px) {
        :global(.blockContainer-width-1000px) {
            width: calc(100% - 20px) !important;
            position: relative !important;
            padding: 10px;
        }
    }
</style>
